export const selectAllUsers = ({ UsersSlice: oState }) => oState?.aUsers;
export const selectStatusUsers = ({ UsersSlice: oState }) => oState?.bStatus;
export const selectStatusChangePasswordUsers = ({ UsersSlice: oState }) => oState?.bStatusChangePassword;
export const selectUserUsers = ({ UsersSlice: oState }) => oState?.oUser;
